var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligibleIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44948",
    "data-name": "Group 44948",
    transform: "translate(69 -284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63935",
    "data-name": "Rectangle 63935",
    width: 25,
    height: 25,
    transform: "translate(-69 284)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44943",
    "data-name": "Group 44943",
    transform: "translate(-109.603 -38.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44563",
    "data-name": "Group 44563",
    transform: "translate(41.603 326.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89159",
    "data-name": "Path 89159",
    d: "M24.236,11.364V1.256A.506.506,0,0,0,23.73.75H10.589a.505.505,0,0,0-.5.506V2.267",
    transform: "translate(-3.008 -0.75)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89160",
    "data-name": "Path 89160",
    d: "M15.362,14.751H27.349c0,1.516-1.011,2.022-2.527,2.022H16.886",
    transform: "translate(-4.099 -4.137)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89161",
    "data-name": "Path 89161",
    d: "M6.449,12.332A3.107,3.107,0,0,1,3.417,9.083V8A3.107,3.107,0,0,1,6.449,4.751,3.107,3.107,0,0,1,9.482,8V9.083A3.107,3.107,0,0,1,6.449,12.332Z",
    transform: "translate(-1.395 -1.718)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89162",
    "data-name": "Path 89162",
    d: "M.75,19.3v-.91C.75,15.9,4.006,14.75,5.8,14.75s5.054,1.124,5.054,3.618V19.3",
    transform: "translate(-0.75 -4.136)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89163",
    "data-name": "Path 89163",
    d: "M18.772,8.471a2.071,2.071,0,0,0,2.022-2.166V5.583a2.027,2.027,0,1,0-4.044,0v.722A2.071,2.071,0,0,0,18.772,8.471Z",
    transform: "translate(-4.62 -1.395)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89164",
    "data-name": "Path 89164",
    d: "M21.482,12.1c0-1.384-1.954-2.022-3.032-2.022s-3.032.625-3.032,2.01",
    transform: "translate(-4.298 -3.007)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibleIco);
export default __webpack_public_path__ + "static/media/eligible-ico.5f96164174a6ed67198ce49e7d288aad.svg";
export { ForwardRef as ReactComponent };